export var botDeepLink = function (deepLink) {
    var resultLink = "https://t.me/".concat(process.env.BOT_NAME, "?start=").concat(deepLink);
    window.location.href = resultLink;
};
